import React from 'react';

interface NotificationCardProps {
  iconSrc: string;
  title: string;
  buttonText?: string;
  classname?: string;
  titleTextClassName?: string;
  onButtonClick?: () => void;
}

const NotificationCard: React.FC<NotificationCardProps> = ({
  iconSrc,
  title,
  buttonText,
  classname,
  titleTextClassName,
  onButtonClick,
}) => {
  return (
    <section
      className={`flex flex-col sm:flex-row items-start sm:items-center sm:justify-between bg-white rounded-md shadow-sm border border-slate-100 gap-3 sm:gap-4 ${classname}`}
    >
      <div className="flex items-center gap-2 sm:gap-3">
        <img
          loading="lazy"
          src={iconSrc}
          alt=""
          className="w-4 h-4 sm:w-5 sm:h-5 object-contain"
        />
        <h2 className={`font-semibold text-stone-900 text-sm sm:text-base ${titleTextClassName}`}>
          {title}
        </h2>
      </div>

      {buttonText && (
        <div className="flex items-center w-full sm:w-auto">
          <button
            className="px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-medium bg-white rounded-md border border-slate-200 text-slate-900 cursor-pointer w-full sm:w-auto"
            onClick={onButtonClick}
          >
            {buttonText}
          </button>
        </div>
      )}
    </section>
  );
};

export default NotificationCard;
